// atom/userLevelState.js 파일

import { atom } from "recoil";

export const userLevelState = atom({
  key: "userLevelState",
  default: "",
});
